import { type AvatarSex } from "@seddi/avatar";
import {
  type CoverageColor,
  type CoverageLevel,
  type SkinTone,
} from "./displayTypes";

export enum AvatarTextureLayer {
  BOTTOM = "BOTTOM",
  SKIN = "SKIN",
  TOP = "TOP",
}

/**
 * Avatar textures descriptor.
 */
export interface AvatarTexturesDesc {
  coverageBottom: CoverageLevel;
  coverageColor: CoverageColor;
  coverageTop: CoverageLevel;
  isBottomDisabled: boolean;
  isTopDisabled: boolean;
  sex: AvatarSex;
  skin: SkinTone;
}

/**
 * Avatar textures data.
 */
export interface AvatarTexturesData {
  baseColor: Uint8ClampedArray;
  normal: Uint8ClampedArray;
  roughness: Uint8ClampedArray;
  specular: Uint8ClampedArray;
}
